/* eslint-disable no-undef */
import * as GibberishAES from 'gibberish-aes/src/gibberish-aes';
export default {
  Encrypt: function (plaintext) {
    return GibberishAES.enc(plaintext, process.env.VUE_APP_CRYPTO_SERVICES)
  },
  Decrypt: function (encrypttext){
    return GibberishAES.dec(encrypttext, process.env.VUE_APP_CRYPTO_SERVICES)
  },
};